module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.request
    },
    on: {
      "ok": _vm.emit
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_vm._v("\n    Link a JotForm to AppointmentGuru\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "blue lighten-4 pa-2"
  }, [_c('v-subheader', {
    staticClass: "overline pa-0 ma-0"
  }, [_vm._v("Info:")]), _vm._v("\n      When you link a JotForm to AppointmentGuru, you will be able to share the form with\n      your AppointmentGuru clients and connect information from their form submissions\n      to their client profile\n    ")], 1), _vm._v(" "), _c('space-picker', {
    attrs: {
      "multiple": "",
      "label": "Which spaces do you want to use this form in?",
      "with-select": false
    },
    model: {
      value: (_vm.spaces),
      callback: function($$v) {
        _vm.spaces = $$v
      },
      expression: "spaces"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "persistent-hint": "",
      "label": "Link this form",
      "hint": "Include a link to this form in notifications, on the client appointment information page and in your appointment link page"
    },
    model: {
      value: (_vm.withLink),
      callback: function($$v) {
        _vm.withLink = $$v
      },
      expression: "withLink"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.request.loading
    },
    on: {
      "click": function($event) {
        return _vm.link(_vm.form.id)
      }
    }
  }, [_vm._v("Link form")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f737992","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/JotForm/LinkJotForm.vue
// module id = 1670
// module chunks = 0